import { useJobsStore } from '@/store/jobs'
export const useJobs = () => {

  const jobsStore = useJobsStore()
  const baseUrl = useRuntimeConfig().public.goliathUrl
  const client = useFetchClient(baseUrl, 'Goliath API - Jobs')

  const getJobs = async () => {
    if (jobsStore.jobs.length === 0) {
      const url = `/job/all`
      const response = await client.get(url)
      const jobs = response.data.jobs
      jobsStore.setJobs(jobs)  
    }
    return jobsStore.jobs
  }

  const getJobDetails = async (id) => {
    if (jobsStore.job[id] === undefined) {
      const url = `/job/${id}`
      const response = await client.get(url)
      jobsStore.setJob(id,response.data.job)
    }
    return jobsStore.job[id]
  }

  return {
    getJobs,
    getJobDetails,
  }
}
